import { render, staticRenderFns } from "./HandicapRoundDialog.vue?vue&type=template&id=2555f1f8"
import script from "./HandicapRoundDialog.vue?vue&type=script&lang=js"
export * from "./HandicapRoundDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports